import { render } from "./subscribe.vue?vue&type=template&id=2d8baaef&scoped=true"
import script from "./subscribe.vue?vue&type=script&lang=js"
export * from "./subscribe.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8baaef"]])

export default __exports__